import React from 'react';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import { ConditionsData } from './ConditionsData';
import { Condition } from '../../components';

const Conditions = () => {
  return (
    <AppSection className="conditions">
      <Container>
        <AppTitle>Какие условия мы предлагаем</AppTitle>
        <ConditionsBlock>
          {ConditionsData.map(({ alt, text }, index) => (
            <Condition key={index} alt={alt} text={text} />
          ))}
        </ConditionsBlock>
      </Container>
    </AppSection>
  );
};

export const AppSection = styled.section`
  padding: 80px 0;
  position: relative;
  @media (max-width: 1200px) {
    padding: 60px 0;
  }
`;

export const AppTitle = styled.h2`
  font-weight: 600;
  font-size: 40px;
  @media (max-width: 600px) {
    font-size: 28px;
    line-height: 40px;
  }
`;

const ConditionsBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 6rem;
  justify-content: center;
  gap: 6.5rem;
  @media (max-width: 1135px) {
    gap: 0;
    row-gap: 4rem;
    justify-content: space-around;
    margin-top: 4rem;
  }
  @media (max-width: 600px) {
    row-gap: 5.9rem;
  }
`;

export default Conditions;
